import { lazy } from "react";
import { createBrowserRouter, NavLink, useRouteError } from "react-router-dom";
import { QueryError } from "@/components/common";
import { ChatShell } from "@/components/chat/ChatShell";
const ChatPage = lazy(() =>
  import("@/pages/ChatPage").then((m) => ({ default: m.ChatPage })),
);

const VariantsPage = lazy(() =>
  import("@/pages/VariantsPage").then((m) => ({ default: m.VariantsPage })),
);
const VariantWorkspace = lazy(() =>
  import("@/pages/VariantWorkspace").then((m) => ({
    default: m.VariantWorkspace,
  })),
);
const PublicationsPage = lazy(() =>
  import("@/pages/PublicationsPage").then((m) => ({
    default: m.PublicationsPage,
  })),
);
const PublicationReader = lazy(() => import("@/pages/PublicationReader"));
const GapsPage = lazy(() =>
  import("@/pages/GapsPage").then((m) => ({ default: m.GapsPage })),
);
const StandardsPage = lazy(() =>
  import("@/pages/StandardsPage").then((m) => ({ default: m.StandardsPage })),
);
function RouteError() {
  const error = useRouteError();
  return (
    <div className="p-8">
      <h1 className="mb-6">页面未能打开</h1>
      <QueryError error={error} />
      <a className="subtle-link inline-block mt-6" href="/">
        返回判读助手
      </a>
    </div>
  );
}
export const router = createBrowserRouter([
  {
    element: <ChatShell />,
    errorElement: <RouteError />,
    children: [
      { index: true, element: <ChatPage /> },
      { path: "runs/:id", element: <ChatPage /> },
      { path: "variants", element: <VariantsPage /> },
      { path: "variants/:id", element: <VariantWorkspace /> },
      { path: "publications", element: <PublicationsPage /> },
      { path: "publications/:id", element: <PublicationReader /> },
      { path: "gaps", element: <GapsPage /> },
      { path: "standards", element: <StandardsPage /> },
      {
        path: "*",
        element: (
          <div>
            <h1>没有找到这个页面</h1>
            <NavLink to="/" className="subtle-link">
              返回判读助手
            </NavLink>
          </div>
        ),
      },
    ],
  },
]);
